import enUS from './en-US';
import de from './de';
import fr from './fr-FR';
import da from './da';
import nlNL from './nl-NL';
import noNO from './no-NO';
import svSE from './sv-SE';

export default {
  da,
  de,
  'en-US': enUS,
  'fr-FR': fr,
  'nl-NL': nlNL,
  'no-NO': noNO,
  'sv-SE': svSE,
};
